import { ObbAnnotation } from "../../api/Application";
import { DrawingStateFns, Mode, ModeVehicleExtras } from "./ModeContext";

export enum VehicleExtra {
    Shade    = "shade",
    Occluded = "occluded",
    Rare     = "rare",
}

export function createExtrasMode( extra: VehicleExtra ): ModeVehicleExtras {
    return { mode: Mode.VehicleExtras, extra };
}

function setExtraAttr( ann: ObbAnnotation, extra: VehicleExtra ) {
    const attrs = ann.attributes;
    if( extra === VehicleExtra.Shade ) {
        const val = attrs.shade != null ? !attrs.shade : true;
        return { ...ann, attributes: { ...attrs, shade: val } };
    }
    if( extra === VehicleExtra.Occluded ) {
        const val = attrs.occluded != null ? !attrs.occluded : true; 
        return { ...ann, attributes: { ...attrs, occluded: !attrs.occluded } };
    }
    if( extra === VehicleExtra.Rare ) {
        const val = attrs.rare != null ? !attrs.rare : true; 
        return { ...ann, attributes: { ...attrs, rare: !attrs.rare } };
    }
    console.error( "Invalid Extra Type!" );
    throw new Error( "Invalid Extra Type!" );
}

function isActive( ann: any, extra: VehicleExtra ) {
    const attrs = ann.attributes ?? {};
    if( extra === VehicleExtra.Shade )    { return !!attrs.shade; }
    if( extra === VehicleExtra.Occluded ) { return !!attrs.occluded; }
    return !!attrs.rare;
}

export const vehicleExtrasModeFns: DrawingStateFns = {
    getCommandSlots( drawMode ) {
        const m = drawMode as ModeVehicleExtras;
        return [
            null, null, null, null, null,
            null, null, null, null, null,            
            { key: "z", label: "Shade",  color: "black", active: m.extra === VehicleExtra.Shade    },
            { key: "x", label: "Occlud", color: "black", active: m.extra === VehicleExtra.Occluded },
            { key: "c", label: "Rare",   color: "black", active: m.extra === VehicleExtra.Rare     },
            null, null
        ];
    },

    onKeyDown( drawMode, key, shift, ctx ) {
        const mode = drawMode as ModeVehicleExtras;
        if( !shift && key === "z" ) { ctx.setDrawMode( { ...mode, extra: VehicleExtra.Shade    } ); return true; }
        if( !shift && key === "x" ) { ctx.setDrawMode( { ...mode, extra: VehicleExtra.Occluded } ); return true; }
        if( !shift && key === "c" ) { ctx.setDrawMode( { ...mode, extra: VehicleExtra.Rare     } ); return true; }
        return false;
    },

    onDeckClick( drawMode, info, ctx ) {},

    onDeckHover( drawMode, info, ctx ) {},

    onAnnotationClick( drawMode, ann, ctx ) {
        const mode = drawMode as ModeVehicleExtras;
        ctx.handleEdit( setExtraAttr( ann, mode.extra ) );
    },

    filter( drawMode, ann ) {
        const mode = drawMode as ModeVehicleExtras;
        return isActive( ann, mode.extra );
    },

    getLineColor( drawMode, ann, ctx ) {
        const mode  = drawMode as ModeVehicleExtras;
        const done  = isActive( ann, mode.extra );
        const alpha = ann.obbAnnotationId == ctx.hovObj?.obbAnnotationId ? 224 : 160;
        if( done ) { return [   0, 255,   0, alpha ]; }
        return              [ 255, 255,   0, alpha ];
    },

    getCursor( drawMode ) {
        return "grab";
    },

    getAnnotationLabel( drawMode, ann ) {
        const mode = drawMode as ModeVehicleExtras;
        if( mode.extra === VehicleExtra.Shade    ) { return ann.attributes?.shade    === true ? "S" : ""; }
        if( mode.extra === VehicleExtra.Occluded ) { return ann.attributes?.occluded === true ? "O" : ""; }
        if( mode.extra === VehicleExtra.Rare     ) { return ann.attributes?.rare     === true ? "R" : ""; }
        throw new Error( "Invalid Extra Type!" );
    }
};